// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2N1uX","errors":"Errors_errors__1uRSm"};